import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { bloodTypes, foodIntollerances, foodAllergies, traumas, medicalOperations } from "../Util/enum";
import TabellaLista from "../Tabella/TabellaLista";
import { TableDocument } from 'iconsax-react';
import { ColumnFilter } from "../table/FilteringTable/ColumnFilter";
import { format, parseISO } from 'date-fns';
import { apriFile } from "../Util/anteprimaFile";

// Campo read-only in colonna 1/3, stile mockup
const Ro = ({ label, value }) => (
    <Col lg={4}>
        <Form.Group className="mb-3">
            <Form.Label>{label}</Form.Label>
            <Form.Control className="sid-ro-input" type="text" value={value || ''} readOnly tabIndex={-1} />
        </Form.Group>
    </Col>
);

const DatiSanPlayer = (props) => {

    const [certificatesData, setCertificatesData] = useState(null);

    const [formData, setFormData] = useState({
        gruppoSanguigno: '',
        allergieAlimentari: '',
        intolleranzeAlimentari: '',
        traumi: '',
        farmaci: '',
        interventiMedici: '',
        malattieEreditarie: '',
        pressioneSanguignaBassa: '',
        pressioneSanguignaAlta: '',
        frequenzaCardiacaMedia: ''
    });

    useEffect(() => {
        if (props.privateProfile) {
            let playerData = props.privateProfile;

            // Il profilo personale arriva sotto un ramo diverso a seconda di chi e':
            // idsPlay per un player, idsGuru per un maestro, junior per un junior. I
            // campi sanitari sono gli stessi, quindi si normalizza qui e sotto si
            // ragiona su uno solo.
            if (playerData.idsGuru) {
                playerData.idsPlay = playerData.idsGuru;
            } else if (playerData.junior) {
                playerData.idsPlay = playerData.junior;
            }

            if (!playerData.idsPlay) return;

            let myFormData = {};
            
            // console.log(playerData.idsPlay);

            let bloodType_conv = convertBloodType(playerData.idsPlay.bloodType)
            let foodIntollerances_conv = convertFoodIntollerances(playerData.idsPlay.foodIntollerances)
            let foodAllergies_conv = convertFoodAllergies(playerData.idsPlay.foodAllergies)
            let traumas_conv = convertTraumas(playerData.idsPlay.traumas)
            let medicines_conv = convertMedicines(playerData.idsPlay.medicines)
            let medicalOperations_conv = convertMedicalOperations(playerData.idsPlay.medicalOperations)
            let hereditaryDiseases_conv = convertHereditaryDiseases(playerData.idsPlay.hereditaryDiseases)
            
            myFormData.pressioneSanguignaBassa = playerData.idsPlay.averageLowBloodPressure ? playerData.idsPlay.averageLowBloodPressure+' mmHg' : '-';
            myFormData.pressioneSanguignaAlta = playerData.idsPlay.averageHighBloodPressure ? playerData.idsPlay.averageHighBloodPressure+' mmHg' : '-';
            myFormData.frequenzaCardiacaMedia = playerData.idsPlay.averageHeartRate ? playerData.idsPlay.averageHeartRate+' bpm' : '-';
            myFormData.gruppoSanguigno = bloodType_conv ? bloodType_conv : '-';
            myFormData.allergieAlimentari = foodAllergies_conv ? foodAllergies_conv : '-';
            myFormData.intolleranzeAlimentari = foodIntollerances_conv ? foodIntollerances_conv : '-';
            myFormData.traumi = traumas_conv ? traumas_conv : '-';
            myFormData.farmaci = medicines_conv ? medicines_conv : '-';
            myFormData.interventiMedici = medicalOperations_conv ? medicalOperations_conv : '-';
            myFormData.malattieEreditarie = hereditaryDiseases_conv ? hereditaryDiseases_conv : '-';
            
            setFormData(myFormData);

            let new_certificates = [];
            if (playerData.idsPlay.medicalCertificates) {
                playerData.idsPlay.medicalCertificates.forEach(element => {
                    new_certificates.push({
                        "id": element.document.id,
                        "date": format(element.document.uploadedAt, 'dd/MM/yyyy HH:mm:ss'),
                        "expiration": element.expiration ? format(parseISO(element.expiration), 'dd/MM/yyyy') : '-',
                        "document": {
                            'name': element.document.name,
                            'uri': element.document.uri
                        },
                        "state": element.verificationStatus
                    });
                });
            }
            setCertificatesData(new_certificates);
        }

    }, [props]);

    function convertBloodType(key) {
        if(!key) return null;
        for (const element of bloodTypes) {
            if (element.value === key) {
                return element.label;
            }
        }
        return null;
    }

    function convertFoodIntollerances(keys) {
        if(!keys) return '';
        let intollerances_string = '';
        keys.forEach(key => {
            foodIntollerances.forEach(element => {
                if(element.value===key) {
                    intollerances_string += element.label+'. ';
                }
            });
        });
        return intollerances_string;
    }

    function convertFoodAllergies(keys) {
        if(!keys) return '';
        let allergies_string = '';
        keys.forEach(key => {
            foodAllergies.forEach(element => {
                if(element.value===key) {
                    allergies_string += element.label+'. ';
                }
            });
        });
        return allergies_string;
    }

    function convertTraumas(keys) {
        if(!keys) return '';
        let traumas_string = '';
        keys.forEach(key => {
            traumas.forEach(element => {
                if(element.value===key) {
                    traumas_string += element.label+'. ';
                }
            });
        });
        return traumas_string;
    }

    function convertMedicines(keys) {
        if(!keys) return '';
        let medicines_string = '';
        keys.forEach(element => {
            medicines_string += element+'. ';
        });
        return medicines_string;
    }

    function convertMedicalOperations(keys) {
        if(!keys) return '';
        let medicalOp_string = '';
        keys.forEach(key => {
            medicalOperations.forEach(element => {
                if(element.value===key) {
                    medicalOp_string += element.label+'. ';
                }
            });
        });
        return medicalOp_string;
    }

    function convertHereditaryDiseases(keys) {
        if(!keys) return '';
        let herDiseases_string = '';
        keys.forEach(element => {
            herDiseases_string += element+'. ';
        });
        return herDiseases_string;
    }

    // PDF e immagini si aprono nella finestra di anteprima dell'app
    const openCertImage = (documento) => {
        apriFile({ uri: documento.uri, nome: documento.name || 'Certificato medico' });
    };

    const certificates_column = [
        {
            Header: 'Caricamento',
            accessor: 'date',
            Filter: ColumnFilter
        },
        {
            Header: 'Scadenza',
            accessor: 'expiration',
            Filter: ColumnFilter
        },
        {
            Header: 'Documento',
            accessor: 'document',
            Filter: ColumnFilter,
            Cell: ({ value }) => (
                <button type="button" onClick={() => openCertImage(value)} className="btn sid-btn-ghost btn-sm">
                    <TableDocument size="16" variant="Bulk" className="me-1" /> Visualizza
                </button>
            ),
            disableFilters: true,
        },
        {
            Header: 'Stato',
            accessor: 'state',
            Filter: ColumnFilter,
            Cell: ({ value }) => {
                if (value === 'PENDING') return <span><i className="fa fa-circle text-warning me-1"></i> In approvazione</span>;
                if (value === 'APPROVED') return <span><i className="fa fa-circle text-success me-1"></i> Approvato</span>;
                if (value === 'REJECTED') return <span><i className="fa fa-circle text-danger me-1"></i> Rifiutato</span>;
            },
            disableFilters: true,
        }
    ];

    return (
        <>
            <Row>
                <Form>
                    <TabellaLista
                        cardTitle={'Certificati medici'}
                        hasSearch={false}
                        hasFilter={false}
                        hasAddMore={false}
                        data_column={certificates_column}
                        data_json={certificatesData}
                    />
                    {/* `soloCertificati`: la scheda di modifica del super admin mostra qui solo i certificati */}
                    {!props.soloCertificati && <Card className="cardAuto">
                        <Card.Header><h4 className="card-title">Informazioni generiche</h4></Card.Header>
                        <Card.Body>
                            <Row className="mt-3">
                                <Ro label="Gruppo sanguigno" value={formData.gruppoSanguigno} />
                                <Ro label="Battito cardiaco medio" value={formData.frequenzaCardiacaMedia} />
                                <Ro label="Pressione sanguigna bassa media" value={formData.pressioneSanguignaBassa} />
                                <Ro label="Pressione sanguigna alta media" value={formData.pressioneSanguignaAlta} />
                                <Ro label="Allergie alimentari" value={formData.allergieAlimentari} />
                                <Ro label="Intolleranze alimentari" value={formData.intolleranzeAlimentari} />
                                <Ro label="Traumi" value={formData.traumi} />
                                <Ro label="Farmaci" value={formData.farmaci} />
                                <Ro label="Interventi medici" value={formData.interventiMedici} />
                            </Row>
                        </Card.Body>
                    </Card>}
                </Form>
            </Row>
        </>
    )
}
export default DatiSanPlayer;